import marked from "marked";

const mdWho = `# Who we are

Diane & Associates FZ LLC is a United Arab Emirates company
registered in the Commercial Register of the Emirate of Dubai in 2008
and since 2010 with the Emirate of Fujairah.

Its shareholders domiciled in the Middle East own the company.

It is part of a private Group mainly managed from Beirut in Lebanon through a Family Office.
`;

const mdActivities = `# Activities

Diane & Associates provides consulting services and any other
services related thereto, to its shareholders, their other entities
and third parties everywhere where it fully exercises its
expertise:

- Corporate Finance
- Trade in products related to the cosmetics industry
- Triangular or multilateral trade operations
- Private Equity

Its main area of interest extends from Europe, Middle East and
East Asia. The company is also able to rely on its network of
experts, to whom it delegates many tasks, so that it only has to
control, coordinate or implement recommendations within the
framework of its objectives.

The projects that Diane & Associates conducts are long-term
and concern negotiation support, research and prospecting for
activities related to decisions taken by the shareholders.

Diane & Associates receives fees, down payments or dividends
for its activities.

---
`;

const mdHow = `# How does it work ?

The nature of our advisory activity is such that during the course
of our activity we may become aware of secrets or confidential
information, relating to but not limited to operations, operating
methods, financing, technology and know-how.

All such information is the sole property of the Company and its
Business Partners and must remain confidential.

This is why, in the utmost discretion to protect the private
sphere and that of our activities, we only act within the strict
framework of a confidentiality agreement.`;

const mdEthics = `# Ethics and Regulatory Compliance

Being aware of their duties and responsibilities within the
Company’s sphere of influence as a social or economic actor,
our Managerial staff and shareholders are committed to the best
practice standards based upon core values that are essential for
the proper functioning society.`;

const mdContact = `# Address & phone number

Diane & Associates FZ LLC<br/>
Office 404, Al Saaha Offices – B<br/>
Souk Al Bahar, Burj Khalifa District<br/>
P.O. Box 487177<br/>
Dubai / U.A.E.<br/>
Phone +971 4 248 51 33`;

export default {
  who: marked(mdWho),
  activities: marked(mdActivities),
  how: marked(mdHow),
  ethics: marked(mdEthics),
  contact: marked(mdContact),
  menu: [
    "Home",
    "Who we are",
    "Activities",
    "How does it work?",
    "Ethics and Regulatory Compliance",
    "Address & phone number",
  ],
};



// WEBPACK FOOTER //
// ./src/content.js